import { render, staticRenderFns } from "./DocPromotion.vue?vue&type=template&id=3b7ad5d8&scoped=true&"
import script from "./DocPromotion.vue?vue&type=script&lang=js&"
export * from "./DocPromotion.vue?vue&type=script&lang=js&"
import style0 from "./DocPromotion.vue?vue&type=style&index=0&id=3b7ad5d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7ad5d8",
  null
  
)

export default component.exports